import { useState } from "react";
import "./DonationChoice.scss";
import logo from "../../assets/logo.png";

function DonationChoice(props) {
    const handleRecurringChoice = () => {
        props.onChoiceSelected('recurring');
    };

    const handleOneTimeChoice = () => {
        props.onChoiceSelected('onetime');
    };

    const closeModal = () => {
        props.closeDonationChoice(true);
    };

    return (
        <div className="donation-choice-modal">
            <div className="donation-choice-modal__header">
                <img src={logo} alt="ISC Foundation logo" loading="lazy" />
                <p>ISC Foundation</p>
            </div>

            <h2>Support Our Cause<span>!</span></h2>
            <p className="donation-choice-modal__subtitle">Choose how you'd like to contribute</p>

            <div className="donation-options">
                <button type="button" className="donation-option-card recurring" onClick={handleRecurringChoice}>
                    <h3>Set Up Recurring Donation</h3>
                    <p>Support us monthly with automatic contributions</p>
                    <span className="option-badge">Recommended</span>
                </button>

                <button type="button" className="donation-option-card onetime" onClick={handleOneTimeChoice}>
                    <h3>Donate Once</h3>
                    <p>Make a one-time contribution of any amount</p>
                </button>
            </div>

            <button type="button" className="close-btn" onClick={closeModal}>
                Close
            </button>
        </div>
    );
}

export default DonationChoice;